import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyAnnouncementService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CompanyAnnouncement');
	}

	loadAll(): Observable<ePM.Logic.CompanyAnnouncement[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForMe(): Observable<ePM.Logic.CompanyAnnouncement[]> {
		return this.myBaseService.loadAll(this.url + '/Me');
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.CompanyAnnouncement> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.CompanyAnnouncement> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.CompanyAnnouncement> {
		return this.myBaseService.get(id, this.url);
	}
	read(id: System.Guid): Observable<boolean> {
		return this.myBaseService.post(null, this.url + '/Read/' + id);
	}
	search(searchTerm: string): Observable<ePM.Logic.CompanyAnnouncement[]> {
		return this.myBaseService.loadAll(this.url + '/Search/' + searchTerm);
	}
}
